// extracted by mini-css-extract-plugin
export default {"fixedScroll":"Accordion_fixedScroll__kUphs"};